import React, { useState, createContext, useContext, useCallback } from "react"
import Toast from "./Toast"

// Context for managing toasts
const ToastContext = createContext()

export const useToast = () => useContext(ToastContext)

const ToastProvider = ({ children }) => {
	const [toasts, setToasts] = useState([])

	const showToast = useCallback((message, type = "info", duration = 3000) => {
		const id = Date.now() + Math.random() // More unique ID for the toast
		setToasts((prevToasts) => [
			...prevToasts,
			{ id, message, type, duration },
		])
	}, [])

	const removeToast = useCallback((id) => {
		setToasts((prevToasts) =>
			prevToasts.filter((toast) => toast.id !== id)
		)
	}, [])

	return (
		<ToastContext.Provider value={showToast}>
			{children}
			<div>
				{toasts.map((toast) => (
					<Toast
						key={toast.id}
						message={toast.message}
						type={toast.type}
						duration={toast.duration}
						onClose={() => removeToast(toast.id)}
					/>
				))}
			</div>
		</ToastContext.Provider>
	)
}

export default ToastProvider
